<template>
  <b-row class="item-details-container ">
     <b-col>
          <b-list-group-item>
            <a :href="'#item-details-'+item.id" draggable="false" class='wrapper-a' @click="clickToExpanding" >
              <b-row>
                <b-col class="px-0" cols="2" sm="1">
                  <div class="toggle-icon"  @click.prevent>
                    <span v-if="isVisible" aria-hidden="true"><b-icon variant="secondary" icon="caret-right-fill" font-scale="2.2" v-b-popover.hover.left="'View Items'"></b-icon></span>
                    <span v-else aria-hidden="true"><b-icon variant="secondary" icon="caret-down-fill" font-scale="2.2" v-b-popover.hover.left="'View Items'"></b-icon></span>
                  </div>
                </b-col>
                <b-col class="pl-0" cols="7" sm="9">
                    <b-form-input v-model="updItem.name" @change="updateItem()"></b-form-input>
                </b-col>
                <b-col cols="1" class="pl-0 ml-0">
                  <b-form-checkbox v-model="activeItem" switch @input="updateItem()">
                    <span v-if="updItem.active==true">Active</span>
                    <span v-else>Inactive</span>
                  </b-form-checkbox>
                </b-col>
                <!-- <b-col cols="1">
                  <a :href="'#'+$route.path">
                    <b-icon icon="x-circle" variant="danger" font-scale="2.5" v-b-popover.hover.right="'Delete Item'" @click="confirmItemDelete"></b-icon>
                  </a>
                </b-col> -->
              </b-row>
            </a>

            <b-collapse class="category-card" :id="'item-details-'+item.id" v-model="isVisible">
              <b-row>
                <b-col cols="4" sm="2">
                  <label class="pt-1" for="u_std-price" style="float: right;">Price: </label>
                </b-col>
                <b-col cols="4">
                  <b-form-input id="u_std_price" v-model="updItem.std_price" @change="updateItem()"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="4" sm="2">
                  <label class="pt-1" for="u_description" style="float: right;">Description: </label>
                </b-col>
                <b-col cols="8" sm="10">
                  <b-form-input id="u_description" v-model="updItem.description" @change="updateItem()"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="4" sm="2">
                  <label class="pt-1" for="u_image" style="float: right;">Image path: </label>
                </b-col>
                <b-col cols="8" sm="10">
                  <b-form-input id="u_image" v-model="updItem.image_path" @change="updateItem()"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="py-2">
                <b-col class="d-none d-lg-block"></b-col>
                <b-col>
                  <b-form-checkbox v-model="updItem.online"  switch @change="updateItem()">Available online?</b-form-checkbox>
                </b-col>
                <b-col>
                  <b-form-checkbox v-model="updItem.on_premise" switch @change="updateItem()">Available on premise?</b-form-checkbox>
                </b-col>
                <b-col class="d-none d-lg-block"></b-col>
              </b-row>
              <b-row class="py-2">
                <b-col class="d-none d-lg-block"></b-col>
                <b-col>
                  <b-form-checkbox v-model="updItem.is_giftcard"  switch @change="updateItem()">Giftcard?</b-form-checkbox>
                </b-col>
                <b-col>
                  <b-form-checkbox v-model="updItem.allow_price_override" switch @change="updateItem()">Override price?</b-form-checkbox>
                </b-col>
                <b-col class="d-none d-lg-block"></b-col>
              </b-row>
              <b-row class="py-2">
                <b-col style="text-align:center;">
                  <b-button variant="outline-danger" @click="confirmItemDelete">Delete?</b-button>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <h5 style="text-align:center;" class="pt-2">Item Options</h5>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-list-group>
                    <draggable v-model="item.options" @end="dragend" :options="{ forceFallback: true }">
                      <ItemOptions
                        v-for="itemopt of item.options"
                        v-bind:itemopt="itemopt"
                        v-bind:key="itemopt.id"
                        :item_id="item.id"
                        @emit-refresh-options="emitFetchItems"
                        @emit-switch-overlay="emitSwitchOverlay">
                      </ItemOptions>
                    </draggable>
                    <!-- Datalist searching for items to add to category -->
                    <b-list-group-item>
                      <b-form-input v-model="optionname" :list="'option-list'+item.id" placeholder="Search for option" @update="fetchSearchOptions()" @change="addItemOption()"></b-form-input>
                      <datalist :id="'option-list'+item.id">
                        <option v-for="option in options" :key="option.id">{{ option.name }}</option>
                      </datalist>
                    </b-list-group-item>
                  </b-list-group>
                </b-col>
              </b-row>
            </b-collapse>
          </b-list-group-item>
     </b-col>
  </b-row>
</template>
<script>
import ItemOptions from '@/components/ItemOptions.vue'
import draggable from 'vuedraggable';
export default {
  name: 'ItemList',
  components: {
    ItemOptions,
    draggable
  },
  props: ['item'],
  data () {
    return {
      updItem: {
        name: this.item.name,
        description: this.item.description,
        image_path: this.item.image_path,
        std_price: this.item.std_price,
        active: this.item.active,
        online: this.item.online,
        on_premise: this.item.on_premise,
        is_giftcard: this.item.is_giftcard,
        allow_price_override: this.item.allow_price_override
      },
      options: [],
      optionname: '',
      isVisible:false
    }
  },

  computed: {
    activeItem: {
      get: function() {
        return this.item.active;
      },
      set: function(newVal) {
        this.updItem.active = newVal;
      }
    },

    namefilter: function() {
      if (this.optionname != '') {
        return '&name='+this.optionname;
      } else {
        return '';
      }
    },
  },

  methods: {
    clickToExpanding(event){
      const currentIsVisible = this.isVisible ;
      const clickedTag = event.target.tagName ;
      const classTarget = event.target.classList[0];
      if(clickedTag.includes('SPAN') || clickedTag.includes('LABEL') || (clickedTag.includes('INPUT') && event.target.type === 'checkbox' ))
      {
        return ;
      }
      else if(clickedTag.includes('INPUT')|| clickedTag.includes('BUTTON')
              || ( clickedTag.includes('svg') && (classTarget === "bi-x-circle"))
              || (classTarget ==="list-group-item"))
      {
         event.preventDefault();
        this.isVisible = currentIsVisible ;
      }
      else{
        event.preventDefault();
        this.isVisible = !currentIsVisible;
      }

    },
    emitSwitchOverlay(bool) {
      this.$emit('emit-switch-overlay', bool);
    },

    emitFetchItems() {
      this.$emit('emit-fetch-items');
    },

    dragend() {
      var itemoptions = [];
      var i=1;
      for (const itemopt of this.item.options) {
        itemoptions.push({
          "option_header_id": itemopt.id,
          "sort_order": i
        });
        i+=1;
      }
      itemoptions = {"opthead_sort": itemoptions}
      this.updateItemOptionSort(itemoptions);
    },

    async updateItemOptionSort(itemoptions) {
      this.emitSwitchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = itemoptions;
      // update order with status of 'ready'
      const { data } = await this.$api.patch('items/'+this.item.id+'/optionheaders/sortorder',
        body,
        config
      );
      if (data.success == true) {
        this.emitSwitchOverlay(false);
      } else {
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem updating the sort order, please try again later.', {
          title: 'Error updating sort order',
          centered: true
        })
      }
    },

    async fetchSearchOptions() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      // Use Axios to make a call to the API
      const { data } = await this.$api.get("optionheaders?active=True&notitem="+this.item.id+this.namefilter, {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      this.options = await data.optionheaders;
      // this.emitSwitchOverlay(false);
    },

    async addItemOption() {
      // filter the options for a match to the selected option name, then select the relevant id
      const res = this.options.filter(i => i.name == this.optionname);
      var option_id = res[0].id;
      this.emitSwitchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = {
        "opthead_id": option_id
      }
      // update order with status of 'ready'
      const { data } = await this.$api.post('items/'+this.item.id+'/optionheaders',
        body,
        config
      );
      if (data.created == true) {
        this.emitSwitchOverlay(false);
        this.emitFetchItems();
        this.optionname = '';
      } else {
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem adding the option to the item, please try again later.', {
          title: 'Error updating item',
          centered: true
        })
      }
    },

    async confirmItemDelete() {
      if (this.item.options > 0) {
        // If yes, give them this message
        this.$bvModal.msgBoxOk('There are Options associated with this Item. Please remove them before deleting, or consider setting Item to Inactive.', {
          title: 'Unable to Delete',
          centered: true
        })
      } else {
        // if not, get a confirmation before deleting
        this.confirmDel = ''
        this.$bvModal.msgBoxConfirm('Please confirm that you want to delete item '+this.item.name+'!', {
          title: 'Please confirm delete',
          centered: true
        })
        // Confirmed - you can delete the category now!
        .then(value => {
          this.confirmDel = value
          if (this.confirmDel == true) {
            this.deleteItem();
          }
        })
        // Error processing modal
        .catch(err => {
          console.log('an error has occurred. '+ err)
        })
      }
    },

    async updateItem() {
      this.emitSwitchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = {
        "name": this.updItem.name,
        "description": this.updItem.description,
        "image_path": this.updItem.image_path,
        "std_price": this.updItem.std_price,
        "online": this.updItem.online,
        "on_premise": this.updItem.on_premise,
        "is_giftcard": this.updItem.is_giftcard,
        "allow_price_override": this.updItem.allow_price_override,
        "active": this.updItem.active
      }
      // update order with status of 'ready'
      const { data } = await this.$api.patch('items/'+this.item.id,
        body,
        config
      );
      if (data.success == true) {
        this.emitFetchItems();
      } else {
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem updating the item, please try again later.', {
          title: 'Error updating item',
          centered: true
        })
      }
    },

    async deleteItem() {
      this.emitSwitchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      // update order with status of 'ready'
      const { data } = await this.$api.delete('items/'+this.item.id,
        config
      );
      if (data.deleted == true) {
        this.emitFetchItems();
      } else {
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem deleting the item, please try again later.', {
          title: 'Error deleting item',
          centered: true
        })
      }
    },

  }
}
</script>

<style scoped>
 .toggle-icon{
   margin : 6px 5px;
 }
  .wrapper-a{
    text-decoration: none;
    color: initial;
  }
  .wrapper-a:hover{
    text-decoration: none;
    color: initial;
  }
  .list-group-item{
    position: relative;
    border: 0.2px solid rgb(238, 238, 238) ;
    margin: 10px 0px;
    border-radius: 6px;
    box-shadow: 0 1px 0px rgb(84 70 35 / 15%), 0 0px 2px 0px rgb(84 70 35 / 15%);
  }
  .list-group-item:hover{
    box-shadow: 0 2px 6px rgb(84 70 35 / 15%), 0 1px 3px rgb(84 70 35 / 15%);
  }

  .item-details-container > .col{
    padding: 0px;
  }
  .draggable-btn{
    position: relative;
    margin: auto 0px;
    cursor: pointer;
  }
  .draggable-btn > * {
    transform: rotateZ(270deg);
  }
  .form-control{
    outline: none;
    border-inline: none;
    border: none;
  }
  .form-control:focus{
    border-color: gray;
    box-shadow: 0 0 0px 1px rgb(109 109 109 / 25%);
    background-color: transparent;
    outline: 0;
  }
</style>
